// AI-ASSISTED: generated with claude-code on 2026-08-28, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { AppInsightsCard } from './AppInsightsCard';

const appInsightsCard = EntityCardBlueprint.make({
  name: 'app-insights',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { AppInsightsCard } = await import('./AppInsightsCard');
      return <AppInsightsCard />;
    },
  },
});

export const appInsightsCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [appInsightsCard],
});
